<section class="custom-route__planner">
  <header class="planner__header">
    @if (!isEditRouteView()) {
      <app-route-days [fromHeaderPlanner]="true"/>  
      <app-route-day />
    }
  </header>

  <main>
    @if (isEditRouteView()) {
      <app-edit-route />
    } @else if (isBuyTicketsView()) {
      <app-buy-tickets />
    } @else {
      <app-route-timeline />
    }
  </main>
</section>
